import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/projects/$projectId/screening/adjudication",
)({
  beforeLoad: ({ params, location }) => {
    const search = location.search as { citationId?: string };
    throw redirect({
      to: "/projects/$projectId/screening/title-abstract/conflicts",
      params: { projectId: params.projectId },
      search: search.citationId ? { citationId: search.citationId } : {},
      replace: true,
    });
  },
});
